import React, { useEffect, useState } from "react";
import "./DeviceManagement.scss";
import TableFilterHeader from "../../components/TableHeader/TableFilterHeader";
import { useSelector, useDispatch } from "react-redux";
import { getUserList } from "../../store/redux/users";
import { getUsers } from "../../util/API/customers";
import { listMerchantByPrograms } from "../../util/API/agent";
import { getAgentsList } from "../../store/redux/agents";
import CreateAgentModal from "../../components/CreateAgentModal/CreateAgentModal";
import AgentMapModal from "../../components/AgentMapModal/AgentMapModal";
import DeviceManagementTable from "../../components/DeviceManagementTable/DeviceManagementTable";
import DeviceManagementHeader from "../../components/DeviceManagementHeader/DeviceManagementHeader";
import BroadcastModal from "../../components/BroadcastModal/BroadcastModal";
import DeviceDetails from "../../components/DeviceDetails/DeviceDetails";
import DeviceTabs from "../../components/DeviceTabs/DeviceTabs";

let fakeData = [
  {
    Vmerchantpi: {
      userid: 23,
      name: "Bike Shop",
      country: "CAN",
      allowed: 1,
      businessaddress1: "101 Yonge Street",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M2H 2Q7",
      businessname: "Bike Shop",
      zones: 1,
    },
  },
  {
    Vmerchantpi: {
      userid: 21,

      name: "Coffee Roasters",
      country: "CAN",
      allowed: 1,
      businessaddress1: "10 Dundas East",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5B 2G9",
      businessname: "Coffee Roasters",
      zones: 2,
    },
  },
  {
    Vmerchantpi: {
      userid: 13,

      name: "Gourmet Bakery",
      country: "CAN",
      allowed: 0,
      businessaddress1: "220 Yonge Street",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5B 2H1",
      businessname: "Gourmet Bakery",
      zones: 3,
    },
  },
  {
    Vmerchantpi: {
      userid: 10,

      name: "Tech Solutions",
      country: "CAN",
      allowed: 0,
      businessaddress1: "483 Bay Street",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5G 2C9",
      businessname: "Tech Solutions",
      zones: 4,
    },
  },
  {
    Vmerchantpi: {
      userid: 9,

      name: "Book Haven",
      country: "CAN",
      allowed: 1,
      businessaddress1: "214 College Street",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5T 3A1",
      businessname: "Book Haven",
      zones: 5,
    },
  },
  {
    Vmerchantpi: {
      userid: 8,

      name: "Outdoor Gear",
      country: "CAN",
      allowed: 0,
      businessaddress1: "3401 Dufferin Street",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M6A 2T9",
      businessname: "Outdoor Gear",
      zones: 1,
    },
  },
  {
    Vmerchantpi: {
      userid: 27,
      name: "Fine Jewelry",
      country: "CAN",
      allowed: 1,
      businessaddress1: "176 Yonge Street",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5C 2L7",
      businessname: "Fine Jewelry",
      zones: 2,
    },
  },
  {
    Vmerchantpi: {
      userid: 2,
      name: "Pet Paradise",
      country: "CAN",
      allowed: 0,
      businessaddress1: "245 Queens Quay West",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5J 2K9",
      businessname: "Pet Paradise",
      zones: 3,
    },
  },
  {
    Vmerchantpi: {
      userid: 33,

      name: "Gaming World",
      country: "CAN",
      allowed: 1,
      businessaddress1: "388 Spadina Avenue",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5T 2G5",
      businessname: "Gaming World",
      zones: 4,
    },
  },
  {
    Vmerchantpi: {
      userid: 43,

      name: "Vintage Vinyl",
      country: "CAN",
      allowed: 0,
      businessaddress1: "623 Queen Street West",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5V 2B7",
      businessname: "Vintage Vinyl",
      zones: 5,
    },
  },
  {
    Vmerchantpi: {
      userid: 43,

      name: "Health & Wellness Spa",
      country: "CAN",
      allowed: 1,
      businessaddress1: "100 King Street West",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5X 1K7",
      businessname: "Health & Wellness Spa",
      zones: 1,
    },
  },
  {
    Vmerchantpi: {
      userid: 53,

      name: "Modern Art Gallery",
      country: "CAN",
      allowed: 1,
      businessaddress1: "317 Dundas Street West",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5T 1G4",
      businessname: "Modern Art Gallery",
      zones: 2,
    },
  },
  {
    Vmerchantpi: {
      userid: 73,

      name: "Urban Gardening Shop",
      country: "CAN",
      allowed: 1,
      businessaddress1: "777 Bay Street",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5G 2C8",
      businessname: "Urban Gardening Shop",
      zones: 3,
    },
  },
  {
    Vmerchantpi: {
      userid: 93,

      name: "Luxury Watch Store",
      country: "CAN",
      allowed: 1,
      businessaddress1: "261 Queen Street West",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M5V 1Z4",
      businessname: "Luxury Watch Store",
      zones: 4,
    },
  },
  {
    Vmerchantpi: {
      userid: 923,

      name: "Eco-Friendly Clothing",
      country: "CAN",
      allowed: 1,
      businessaddress1: "900 Dufferin Street",
      businesscity: "Toronto",
      businessstate: "Ontario",
      businesscountry: "CAN",
      businesszipcode: "M6H 4A9",
      businessname: "Eco-Friendly Clothing",
      zones: 5,
    },
  },
];

function DeviceManagement() {
  const [selectedUser, setSelectedUser] = useState(null);
  const [previousUsers, setPreviousUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [openBroadcast, setOpenBroadcast] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filterType, setFilterType] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenBroadcast = () => setOpenBroadcast(true);
  const handleCloseBroadcast = () => setOpenBroadcast(false);

  const dispatch = useDispatch();
  const userData = useSelector((state) => state.usersList.users);

  useEffect(() => {
    async function getList() {
      let userList = await getUsers();
      dispatch(getUserList({ users: userList }));
    }

    getList();
  }, []);

  useEffect(() => {
    if (userData) {
      if (searchText.trim() === "") {
        setFilteredUsers(fakeData);
      } else {
        const filtered = fakeData.filter(
          (user) =>
            user.Vmerchantpi.businessname
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            user.Vmerchantpi.businesscountry
              .toLowerCase()
              .includes(searchText.toLowerCase())
        );
        setFilteredUsers(filtered);
      }
    }
  }, [userData, searchText]);

  useEffect(() => {
    //THIS WILL NEED TO BE CHANGED. Fetching merchant as dummy data
    const fetchAgents = async () => {
      const response = await listMerchantByPrograms();
      if (response.callStatus == 1) {
        let agentList = response.payload.body.record;
        dispatch(getAgentsList({ users: agentList }));
      } else {
        dispatch(getAgentsList({ users: [] }));
      }
    };

    fetchAgents();
  }, []);

  const setFilter = (filter) => {
    setFilterType(filter);
  };

  const handleSelectedUser = async (selectedCustomer) => {
    setSelectedUser(selectedCustomer);
  };

  const handleSearch = (searchText) => {
    setSearchText(searchText);
    if (searchText.trim() === "") {
      setFilteredUsers(fakeData);
    } else {
      const filtered = fakeData.filter(
        (user) =>
          user.Vmerchantpi.businessname
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          user.Vmerchantpi.businesscountry
            .toLowerCase()
            .includes(searchText.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
  };

  return (
    <>
      <AgentMapModal open={open} handleClose={handleClose} />
      <BroadcastModal open={openBroadcast} handleClose={handleCloseBroadcast} />
      <>
        <CreateAgentModal open={open} handleClose={handleClose} />
        <div className="page-container crm-container">
          <div>
            <div
              className={`page-title`}
              style={{ transition: "all 0.5s ease-in-out" }}
            >
              <div className="crm-row-style">
                <p>Device Management</p>
                <TableFilterHeader
                  handleSearch={handleSearch}
                  handleOpen={handleOpen}
                  pageName={"Device Management"}
                />
              </div>
            </div>
          </div>

          <div className="customer-table-container">
            <DeviceManagementHeader
              count={filteredUsers.length}
              setFilter={setFilter}
              handleOpen={handleOpen}
              handleOpenBroadcast={handleOpenBroadcast}
              user={"Devices"}
            />

            <DeviceManagementTable
              userData={filteredUsers}
              handleSelectedUser={handleSelectedUser}
            />
          </div>

          <div
            class="offcanvas offcanvas-end dynamic-offcanvas"
            tabindex="-1"
            id="offcanvasRightLoan"
            aria-labelledby="offcanvasRightLabel"
          >
            <div className="customer-bottom-info">
              <div class="text-end p-2">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div className="customer-bottom-box2">
                <DeviceDetails
                  selectedUser={selectedUser}
                  setSelectedUserData={setSelectedUserData}
                />
              </div>

              <div className="customer-bottom-box">
                <DeviceTabs
                  selectedUser={selectedUser}
                  selectedUserData={selectedUserData}
                  setSelectedUserData={setSelectedUserData}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
}

export default DeviceManagement;
